import { render, staticRenderFns } from "./FriendshipStatus.vue?vue&type=template&id=0efcbdaa"
import script from "./FriendshipStatus.vue?vue&type=script&lang=ts"
export * from "./FriendshipStatus.vue?vue&type=script&lang=ts"
import style0 from "./FriendshipStatus.vue?vue&type=style&index=0&id=0efcbdaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports